import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-upload-dialog',
  templateUrl: './upload-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadDialogComponent {
  readonly dialogRef = inject(MatDialogRef<UploadDialogComponent>);
}
